// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__1Y4uV","col":"CardReaderDesc_col__2Fbim","label":"CardReaderDesc_label__2Vg9Y"};